<div class="dictionary-details-page">
  <div class="page-header">
    <div>
      <a class="back-link" [routerLink]="['/admin/dictionaries']">
        <mat-icon>arrow_back</mat-icon>
        <span>Back to dictionaries</span>
      </a>
      <h1>
        Dictionary
        @if (dictStat) {
          <span class="readonly-value">{{ dictStat.name }}</span>
        }
      </h1>
    </div>
  </div>

  @if (loading) {
    <div class="loading-state">
      <mat-spinner [diameter]="32"></mat-spinner>
      <span>Loading dictionary...</span>
    </div>
  } @else if (notFound || !dictStat) {
    <mat-card class="empty-state-card">
      <mat-card-content>
        <mat-icon>search_off</mat-icon>
        <h2>Dictionary not found</h2>
        <p>The dictionary may have been removed or is not available for this tenant.</p>
        <button mat-raised-button color="primary" (click)="backToList()">Back to dictionaries</button>
      </mat-card-content>
    </mat-card>
  } @else {
    <section class="overview-grid">
      <mat-card class="status-card">
        <mat-card-header>
          <mat-card-title>Overview</mat-card-title>
          <mat-card-subtitle>ID {{ dictStat.id }}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="status-row">
            <pub-sync-status-indicator
              [status]="dictStat.deleted ? 'DELETED' : dictStat.syncStats.status"
              [message]="dictStat.syncStats.statusMessage || ''"></pub-sync-status-indicator>
            <span class="status-pill" [ngClass]="statusClass()">{{ statusLabel() }}</span>
          </div>

          @if (dictStat.syncStats.statusMessage) {
            <p class="status-message">{{ dictStat.syncStats.statusMessage }}</p>
          }

          <div class="metric-grid">
            <div class="metric">
              <span class="metric-label">TermWeb concepts</span>
              <strong>{{ dictStat.termWebConceptCount }}</strong>
            </div>
            <div class="metric">
              <span class="metric-label">Published concepts</span>
              <strong>{{ publishedConceptCount() }}</strong>
            </div>
            <div class="metric">
              <span class="metric-label">Last sync</span>
              <strong>{{ lastSyncDate() }}</strong>
            </div>
            <div class="metric">
              <span class="metric-label">Sync duration</span>
              <strong>{{ syncDuration() }}</strong>
            </div>
          </div>

          @if (initialSyncDuration()) {
            <p class="secondary-info">Initial synchronization time: {{ initialSyncDuration() }}</p>
          }
        </mat-card-content>
      </mat-card>

      @if (suggestionsEnabled) {
        <mat-card class="suggestions-card">
          <mat-card-header>
            <mat-card-title>Term suggestions</mat-card-title>
            <mat-card-subtitle>Choose where approved suggestions are created in TermWeb.</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <pub-dictionary-suggestion-settings [dictId]="dictStat.id"></pub-dictionary-suggestion-settings>
          </mat-card-content>
        </mat-card>
      }
    </section>

    <mat-card class="visibility-card">
      <mat-card-header>
        <mat-card-title>Visibility</mat-card-title>
        <mat-card-subtitle>Control which languages and sections are available in the published search.</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div class="visibility-grid">
          <pub-languages-panel [dictStat]="dictStat"></pub-languages-panel>
          <pub-sections-panel [dictStat]="dictStat"></pub-sections-panel>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="danger-card">
      <mat-card-content>
        <div class="danger-row">
          <div>
            <h3>Delete index</h3>
            <p>Deletes all synchronized data for this dictionary. The dictionary can be indexed again afterwards.</p>
          </div>
          <button mat-raised-button color="warn" (click)="deleteIndexPrompt()"
                  [disabled]="(!isComplete() && !dictStat.deleted) || isInProgress()">
            <mat-icon>delete</mat-icon>
            <span class="icon-text">Delete index</span>
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  }
</div>
